import { render, staticRenderFns } from "./RiskSurveyDet.vue?vue&type=template&id=670a35cd&"
import script from "./RiskSurveyDet.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyDet.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyDet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports